export class UserPhoneNumberEntity {
  number: string;
  extension: string;

  constructor() {
    this.number = '';
    this.extension = '';
  }
}
